import {EyeIcon, CheckIcon, FileDiffIcon, XIcon, type Icon as PrimerIcon} from '@primer/octicons-react'
import type {ReviewSummaryState} from '../../../../page-data/payloads/review-summaries'
import type {ForYouLeadingIconVariant} from '../../for-you/shared/ForYouLeadingIcon'

type ReviewStateDisplay = {
  icon: PrimerIcon
  variant: ForYouLeadingIconVariant
  text: string
}

export const REVIEW_STATE_DISPLAY: Record<ReviewSummaryState, ReviewStateDisplay> = {
  COMMENTED: {icon: EyeIcon, variant: 'default', text: 'reviewed'},
  APPROVED: {icon: CheckIcon, variant: 'success', text: 'approved'},
  CHANGES_REQUESTED: {icon: FileDiffIcon, variant: 'danger', text: 'requested changes'},
  DISMISSED: {icon: XIcon, variant: 'default', text: 'dismissed'},
}
